var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid px-md-4"},[_c('h3',[_vm._v("Redirecting to Login")]),_c('div',{staticClass:"loader m-auto"})])}]

export { render, staticRenderFns }